import { addChapterControl } from "../chapters";

export default function (pl) {
  let player = pl;
  let loaded = false;

  // must be youtube and player must have container
  if (player?.config?.provider !== "youtube" || !player?.elements?.container) {
    return;
  }

  const $cover = jQuery(player?.elements?.container)
    .closest(".presto-player__wrapper")
    .find(".presto-player__play-cover");

  if (!$cover.length) {
    loadPlayer();
    return;
  }

  // set temp player ratio
  player.ratio = "16:9";

  // always remove cover on click
  $cover.on("click", (e) => {
    jQuery(e.target).remove();
    e.preventDefault();
    loadPlayer();
  });

  // don't lazy load on Safari
  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  if (iOS) {
    $cover.remove();
    loadPlayer();
    return;
  }

  // play the video
  function playVideo(plyr) {
    plyr.play();
    plyr.muted = true;
    plyr.muted = false;
    plyr.off("ready", playVideo);
  }

  // load the player
  function loadPlayer() {
    loaded = true;
    player.source = {
      type: "video",
      sources: [
        {
          src: player?.config?.video_id,
          provider: player?.config?.provider,
        },
      ],
    };
  }

  // if it's ready, play
  player.on("ready", (e) => {
    if (!loaded) {
      return;
    }
    const currentTime = localStorage.getItem(
      `player-progress-${e.detail.plyr?.media?.id}`,
      player?.currentTime
    );
    e.detail.plyr.currentTime = parseInt(currentTime) || 0;
    playVideo(e.detail.plyr);
    addChapterControl(e);
  });
}
